import { render, staticRenderFns } from "./Licence-data.vue?vue&type=template&id=5c6ff1d8"
import script from "./Licence-data.vue?vue&type=script&lang=js"
export * from "./Licence-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports